import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import UserIcon from '../../assets/images/user_img.png';
import { useDispatch } from 'react-redux';
import { logoutAuth } from '../../redux/reducers/AuthSlice';
import Toast from '../../utils/toast';
import { profile } from '../../redux/reducers/ProfileSlice';
import Appointments from './Appointments';
import TransactionHistory from './TransactionHistory';
import MyProfile from './MyProfile';
import AppointmentDetails from './AppointmentDetails';

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { tab, id } = useParams(); // Get tab from URL

  const [profileData, setProfileData] = useState();
  const [activeTab, setActiveTab] = useState("profile"); // Default "profile"
  const [selectedAppointment, setSelectedAppointment] = useState(null); // <-- Added this line

  
  useEffect(() => {
    if (tab) {
      setActiveTab(tab);
    }
  }, [tab]);
  

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const responseProfile = await dispatch(profile());
        setProfileData(responseProfile.payload.data);
      } catch (error) {
        // Error fetching profile data
      }
    };
    fetchProfile();
  }, [dispatch]);

  const handleLogout = () => {
    dispatch(logoutAuth());
    Toast('success', 'You have been logged out successfully.');
    navigate('/login');
  };

  return (
    <>
      <section className="breadcrumb">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb_text">
                <h1>Dashboard</h1>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li>Dashboard</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="dashboard mt_100 xs_mt_70 pb_100 xs_pb_70">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-xl-3 col-lg-4">
              <div className="user_profile">
                <div className="user_profile_img">
                  <img src={profileData?.image} alt="user" className="img-fluid w-100" />
                </div>
                <h4>{profileData?.name} {profileData?.last_name}</h4>
                <p>{profileData?.email}</p>
              </div>

              <ul className="dashboard_menu">
                <li>
                  <Link to="/dashboard/profile">
                    <button className={activeTab === 'profile' ? 'active' : ''}>
                      My Profile
                    </button>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/appointments">
                    <button className={activeTab === 'appointments' ? 'active' : ''}>
                      Appointments
                    </button>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/transactions">
                    <button className={activeTab === 'transactions' ? 'active' : ''}>
                      Transaction History
                    </button>
                  </Link>
                </li>
                <li>
                  <button onClick={handleLogout}>Logout</button>
                </li>
              </ul>
            </div>

            {/* Main Content */}
            <div className="col-xl-9 col-lg-8">
              <div className="dashboard_content">
                {activeTab === 'profile' && <MyProfile profileData={profileData} />}
                {activeTab === 'appointments' &&  
  <Appointments 
    setActiveTab={setActiveTab} 
    setSelectedAppointment={setSelectedAppointment} 
  />
}

                {activeTab === 'transactions' && <TransactionHistory />}
                {activeTab === 'appointment' && id && (
  <AppointmentDetails setActiveTab={setActiveTab} />
)}

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Dashboard;
